/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
class s {
  constructor(t = [], r = []) {
    this.input = t, this.control = r, this.inputCursor = 0, this.controlCursor = 0;
  }
  eof() {
    return this.inputCursor >= this.input.length;
  }
  // Get the first value from the input.
  next() {
    return {
      char: this.input[this.inputCursor++],
      control: this.control[this.controlCursor++]
    };
  }
  peek() {
    return {
      char: this.input[this.inputCursor],
      control: this.control[this.controlCursor]
    };
  }
  // eslint-disable-next-line camelcase
  eat_input() {
    this.inputCursor++;
  }
  // eslint-disable-next-line camelcase
  eat_control() {
    this.controlCursor++;
  }
  eat() {
    this.inputCursor++, this.controlCursor++;
  }
}
export {
  s as Stream
};
